/* eslint-disable @typescript-eslint/ban-types */
import { ConcurrentPresentation } from './subscribable/concurrent_presentation';
import { Flow, FlowPresentation } from './subscribable/flow_presentation';
import { SynchronousPresentation } from './subscribable/synchronous_presentation';

/**
 * ## cortex:presentation
 *
 * @public
 * @deprecated Use React state/context and custom hooks for UI state. Use TanStack Query for server state.
 * */
export namespace Presentation {
	/**
	 * @deprecated Use React state/context and custom hooks for local UI state instead.
	 */
	export function create<T extends object>(initialValue: T): SynchronousPresentation<T> {
		return new SynchronousPresentation(initialValue);
	}

	/**
	 * @deprecated Use React state/context and custom hooks for local UI state, or TanStack Query for async server state.
	 */
	export function createConcurrent<T extends object>(initialValue?: T): ConcurrentPresentation<T> {
		return new ConcurrentPresentation(initialValue);
	}

	/**
	 * @deprecated Use React state/context and custom hooks for local UI state, or TanStack Query for loading/error server state.
	 */
	export function createFlow<T extends object>(spec: { initialValue?: T; designatedFlowState?: Flow } = {}): FlowPresentation<T> {
		return new FlowPresentation({
			initialValue: spec.initialValue,
			designatedFlowState: spec.designatedFlowState,
		});
	}
}
